import React from 'react'
import { Loader } from '@livechat/design-system-react-components'
import { string } from 'prop-types'

const MinimalisticLoader = ({
  loaderSize = 'small',
  className = '',
  primaryColor,
  secondaryColor,
}) => {
  return (
    <Loader
      size={loaderSize}
      className={`minimalistic-loader ${className}`}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
    />
  )
}

MinimalisticLoader.propTypes = {
  loaderSize: string,
  className: string,
  primaryColor: string,
  secondaryColor: string,
}

export default MinimalisticLoader
